import { z } from "zod"

/**
 * Dashboard Types
 * Based on GET /organizations/{slug}/dashboard from swagger.json
 */

export const dashboardPeopleSchema = z.object({
  customers: z.number(),
  suppliers: z.number(),
})

export const dashboardAccountSchema = z.object({
  id: z.string(),
  name: z.string(),
  currentBalance: z.number(),
  projectedBalance: z.number(),
})

export const dashboardFinanceSchema = z.object({
  currentBalance: z.number(),
  projectedBalance: z.number(),
  accounts: z.array(dashboardAccountSchema),
})

export const getDashboardResponseSchema = z.object({
  people: dashboardPeopleSchema,
  finance: dashboardFinanceSchema,
})

export type TDashboardPeople = z.infer<typeof dashboardPeopleSchema>
export type TDashboardAccount = z.infer<typeof dashboardAccountSchema>
export type TDashboardFinance = z.infer<typeof dashboardFinanceSchema>
export type TGetDashboardResponse = z.infer<typeof getDashboardResponseSchema>
